module.exports = __webpack_public_path__ + "static/media/service_3.9187b3d0.jpg";